const FooterLangTextA: any = {
    us: {
        PrivacyPolicy: 'Privacy Policy',
        TermsOfUse: 'Terms of Use',
        email_title: 'Join now for 5% off and $1,000+ exclusive coupons!',
        email_desc: '',
        select_country: 'Select your country or region:',
        privacyTerms: [
            {
                text: 'Terms of Use',
                link: 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html',
            },
            {
                text: 'Return & Refund Policy',
                link: 'https://us.ecoflow.com/pages/ecoflow-return-policy',
            },
            {
                text: 'Warranty Policy',
                link: 'https://us.ecoflow.com/pages/warranty-policy',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/us/data-security-and-privacy',
            },
        ],
    },
    // 2
    ca: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            {
                text: 'Terms of Use',
                link: 'https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html',
            },
            {
                text: 'Return & Refund Policy',
                link: 'https://ca.ecoflow.com/pages/ecoflow-return-policy',
            },
            {
                text: 'Warranty Policy',
                link: 'https://ca.ecoflow.com/pages/warranty-policy',
            },
            {
                text: 'Other Policies',
                link: 'https://ca.ecoflow.com/pages/policy',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/ca/data-security-and-privacy',
            },
            {
                text: 'Compliance Statement',
                link: 'https://account.ecoflow.com/agreement/en-ca/Statement.html',
            },
        ],
    },
    // 3
    eu: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            {
                text: 'Who We Are',
                link: 'https://www.ecoflow.com/eu/about-us',
            },
            {
                text: 'Contact Us',
                link: 'https://www.ecoflow.com/eu/contact-us',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html',
            },
            {
                text: 'Terms of Service',
                link: 'https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/eu/data-security-and-privacy',
            },
            {
                text: 'Compliance Statement',
                link: 'https://account.ecoflow.com/agreement/en-eu/Statement.html',
            },
        ],
    },
    // 4
    uk: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 5
    de: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 6
    fr: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 7
    it: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 8
    es: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 9
    jp: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 10
    kr: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 11
    cn: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 12
    tw: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 13
    au: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 14
    za: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 15
    sa: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 16
    mx: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 17
    br: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
    // 18
    ph: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
    },
};

export default FooterLangTextA;
